// extracted by mini-css-extract-plugin
export var circle = "_41-2";
export var icon = "_41-a";
export var iconHighlight = "_41-0";
export var lg = "_41-8";
export var md = "_41-7";
export var outline = "_41-4";
export var sm = "_41-6";
export var square = "_41-1";
export var xl = "_41-9";
export var xs = "_41-5";
export var xxs = "_41-3";